<div data-testid="stock-delivery-manager-page" class="stock-delivery-manager-header px-6 pt-6">
  <h2 class="text-2xl font-semibold text-gray-800 mb-3">
    {{ "outbound_management.title" | translate }}
  </h2>
  <div class="flex">
    @for(tab of deliveryTabs; track tab.value; let i = $index){
    <button
      [attr.data-testid]="'stock-delivery-manager-' + tab.value + '-tab-btn'"
      type="button"
      [class]="
        'px-4 py-2 text-sm font-medium border-b-2 ' +
        (activeTab === tab.value
          ? 'border-blue-500 text-blue-600'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300')
      "
      (click)="onTabChange({ index: i })"
    >
      {{ tab.label | translate }}
    </button>
    }
  </div>
</div>
<router-outlet></router-outlet>
